// 此处存放反转后的只读token，因为源码中的token会被github过滤
export const READONLY_TOKEN_REVESE = '73ac9749da2d38d6a1fd763b6cb6a4dd483af9c6'
// 存放blog的仓库名
export const REPOSITORY_NAME = 'ForeverSc.github.io'
